/**
 * The names the server gives a work agreement's three rooms at hire. A conversation link selects a
 * room by its name (#5826), which is how the Teams page opens a team's chat (#4441).
 */
export const WorkAgreementConversation = {
  AllStakeholders: "All Stakeholders",
  ClientTeam: "Client Team",
  VendorTeam: "Vendor Team",
} as const;
export type WorkAgreementConversation = (typeof WorkAgreementConversation)[keyof typeof WorkAgreementConversation];
